import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatFlashbar = createCustomElementWrapper('kat-flashbar', 'KatFlashbar', {
    'linkHref': 'link-href',
    'linkLabel': 'link-label',
    'linkPreventDefault': 'link-prevent-default',
    'linkTarget': 'link-target',
}, {
    'onDismissed': 'dismissed',
    'onLinkClick': 'link-click',
});
